import React from "react";
import {useMediaQuery} from "beautiful-react-hooks";

const colors = ["#0088FE", "#00C49F", "#FFBB28"];
const delay = 3500;


const items = [

{
  "element":<img src={'images/svg/slide2.svg'} alt={''} className={'iconim5050'} />
,
  "title": 'کارمزد صفر !',
  "caption":'برای معاملات کل ارزها در سینا تتر'
},



    {
        "element":<img src={'images/svg/slide1.svg'} alt={''} className={'iconim5050'} />
,
        "title": '0 تا 100 احراز هویت  تنها در 5 دقیقه!',
        "caption":'سرعت در انجام احراز هویت در مدت ۵ دقیقه!        '
    },


    {
      "element":<img src={'images/svg/slide2.svg'} alt={''} className={'iconim5050'} />
,
      "title": 'بدون محدودیت خرید کن!      ',
      "caption":'واریز بدون محدودیت حجمی و برداشت روزانه تا سقف ۱۰۰ میلیون تومان!      '
  },

    {
        "element": <img src={'images/svg/slide3.svg'} alt={''} className={'iconim5050'}/>
        ,
        "title": 'ماهی گیری از اقیانوس رمز ارزها!        ',
        "caption": ' تنوع بالا رمز ارزها، بیش از ۵۰۰ ارز دیجیتال        '

    },
]

export default function SlideSHowLogin({children}) {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);
  const isSmall = useMediaQuery('(max-width: 768px)')


  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === items.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);





  function handleNext(){

    let next = index + 1 < items.length ? index + 1 : 0
    setIndex(next)
  }




  function handlePrev(){

    let prev = index - 1 < 0 ? 4 - 1 : index - 1;
      setIndex(prev)

  }

  return (
    <>

    {isSmall?
      <>


<div className="box-center5050">
    <img src={'../images/login-img.png'} alt={''} className={'iconim5050'} />



    <div className="slideshow56">

<div
  className="slideshowSlider56"
  style={{ transform: `translate3d(${index * 100}%, 0, 0)` }}
>
<div
      className=""
    >

  {items.map((item, index) => (

    <>
    

        <div className={'subcontent5050 slide56 sub-box5050'} key={index}>
                      <div className={'main-tit5050'}>
  {item.title}
</div>
                      <div className={'content5050'}>
              {item.caption}


                      </div>
                  </div>

                  </>
  ))}
    </div>

</div>









<div className="slideshowDots56">
  {items.map((_, idx) => (
    <div
      key={idx}
      className={`slideshowDot56${index === idx ? " active" : ""}`}
      onClick={() => {
        setIndex(idx);
      }}
    ></div>
  ))}
</div>
</div>

    </div>

    <div className="box-right5050">
        {children}

    </div>
      
      
      </>


      :

    <div className="d-flex heightvh">

    <div className="box-right5050">
        {children}

    </div>

    <div className="box-left5050">
    <img src={'../images/login-img.png'} alt={''} className={'iconim5050'} />



    <div className="slideshow56">

<div
  className="slideshowSlider56"
  style={{ transform: `translate3d(${index * 100}%, 0, 0)` }}
>
<div
      className=""
    >

  {items.map((item, index) => (

    <>
    

        <div className={'subcontent5050 slide56 sub-box5050'} key={index}>
                      <div className={'main-tit5050'}>
  {item.title}
</div>
                      <div className={'content5050'}>
              {item.caption}


                      </div>
                  </div>

                  </>
  ))}
    </div>

</div>









<div className="slideshowDots56">
  {items.map((_, idx) => (
    <div
      key={idx}
      className={`slideshowDot56${index === idx ? " active" : ""}`}
      onClick={() => {
        setIndex(idx);
      }}
    ></div>
  ))}
</div>
</div>

    </div>
   

    </div>

    }

    </>


  );
}

